var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid"},_vm._l((_vm.company),function(i){return _c('div',{key:i},[_c('Card',{attrs:{"info":i}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }